// Components

import algolia from '../components/algolia'
import hero from '../components/hero'

const theme = {
  init() {
    hero.init()
    algolia.init()
  }
}

export default theme